"use client";

import React from "react";

const AstoriaTrustedDentist: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Astoria&apos;s Trusted Dentist for Full Mouth Dental Implants
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Tooth loss affects more than your appearance. It can make eating
          difficult, alter your speech, and change the shape of your face over
          time. If you&apos;re missing most or all of your teeth, a lasting
          solution is available.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Full mouth dental implants in Astoria offer a permanent, fixed
          solution for missing teeth. No dentures. No temporary fixes. Just a
          stable, lasting result. At Smile4Me Dental Care, Dr. Khaimov places
          All-on-6 implants using advanced technology and a patient-first
          approach.
        </p>
      </div>
    </section>
  );
};

export default AstoriaTrustedDentist;
